<template>
  <div class="tol-sidebar">
    <nav
      v-scroll-spy-active="{ class: 'active' }"
      v-scroll-spy-link
      v-bind="attrs"
      class="scroll-nav"
      data-scroll-spy-id="main-tab"
    >
      <div v-for="(item, index) in menuItems" :key="index" class="main-menu">
        <a :id="'nav-tab-' + index" @click="toggleSubmenu(index)">
          <span v-if="item.icon"><font-awesome-icon :icon="item.icon"/></span>
          {{ item.label }}
          <span v-if="item.submenu" class="caret"><font-awesome-icon :icon="upDown(index)"/></span>
        </a>
        <div v-if="item.submenu" class="sub-menu" :class="{ open: isOpen(index) }">
          <div
            v-scroll-spy-active="{ class: 'highlighted' }"
            v-scroll-spy-link
            data-scroll-spy-id="sub-tab"
          >
            <a
              v-for="(subItem, subIndex) in item.submenu"
              :id="'sub-nav-tab-' + index"
              :key="subIndex"
            >
              <span v-if="subItem.icon"><font-awesome-icon :icon="subItem.icon"/></span>
              {{ subItem.label }}
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      openSubmenus: {}
    };
  },
  computed: {
    attrs() {
      return this.$attrs;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    toggleSubmenu(index) {
      this.$set(this.openSubmenus, index, !this.openSubmenus[index]);
    },
    isOpen(index) {
      return this.openSubmenus[index];
    },
    upDown(index) {
      return this.isOpen(index) ? 'caret-up' : 'caret-down';
    },
    onScroll() {
      const sidebarPos = document.querySelector('.tol-sidebar').offsetTop;
      const scrollEl = document.querySelector('.scroll-nav');
      if (scrollEl !== null) {
        if (window.scrollY > sidebarPos) {
          document.querySelector('.scroll-nav').style.position = 'sticky';
          document.querySelector('.scroll-nav').style.top = 0;
        } else {
          document.querySelector('.scroll-nav').style.position = 'relative';
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.tol-sidebar {
  flex: 0 15%;
  position: relative;
  nav.scroll-nav {
    > div:not(:last-of-type) > a {
      border-bottom: 1px solid $mid-blue;
    }

    .main-menu.active > a {
      color: $white;
      font-weight: bold;
      border-right-color: $orange;
    }
    .main-menu {
      .sub-menu,
      .sub-menu > div {
        display: none;
      }
    }
    .main-menu.active {
      .sub-menu.open,
      .sub-menu > div {
        display: block;
      }
    }
    a {
      list-style: none;
      display: flex;
      padding: 15px 25px;
      background-color: $dark-blue;
      color: $mid-blue;
      border-right: 4px solid rgba(255, 255, 255, 0);
      &:hover {
        cursor: pointer;
      }

      .caret {
        margin-left: auto;
      }
    }

    .sub-menu {
      a {
        background-color: $mid-blue;
        color: $dark-blue;
        border-right: 4px solid rgba(255, 255, 255, 0);
        &:not(:last-of-type) {
          border-bottom: 1px solid $dark-blue;
        }
        &.highlighted {
          font-weight: bold;
          border-right: 4px solid $orange;
        }
      }
    }
  }
}
@media print {
  .tol-sidebar {
    display: none;
  }
}
</style>
